import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSource = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40.01 33.02",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:currentColor;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "Asset 4" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer_2",
			"data-name": "Layer 2",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Layer_1-2",
				"data-name": "Layer 1",
				children: /* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M30.34,15.35l-14.17-14a1.65,1.65,0,0,0-2.34,0,1.58,1.58,0,0,0-.49,1.16V9.9H1.67a1.61,1.61,0,0,0-1.17.49A1.58,1.58,0,0,0,0,11.56v9.9a1.58,1.58,0,0,0,.49,1.16,1.61,1.61,0,0,0,1.17.49H13.34v7.43a1.58,1.58,0,0,0,.49,1.16,1.65,1.65,0,0,0,2.34,0l14.17-14a1.61,1.61,0,0,0,0-2.32ZM37.81,2.18A7.26,7.26,0,0,0,32.51,0H24.17a.79.79,0,0,0-.53.17.85.85,0,0,0-.26.5,4.26,4.26,0,0,0-.08.61,6.23,6.23,0,0,0,0,.68c0,.28,0,.45,0,.52a1,1,0,0,0,.05.35.47.47,0,0,0,.18.23l.21.14a.75.75,0,0,0,.3.08l.3,0h8.13a4,4,0,0,1,2.94,1.21,4,4,0,0,1,1.22,2.91V25.59a4,4,0,0,1-1.22,2.91,4,4,0,0,1-2.94,1.21H24.17a.79.79,0,0,0-.53.17.85.85,0,0,0-.26.5,4.26,4.26,0,0,0-.08.61,6.23,6.23,0,0,0,0,.68c0,.28,0,.45,0,.52a.79.79,0,0,0,.25.58.8.8,0,0,0,.59.25h8.34a7.26,7.26,0,0,0,5.3-2.18A7.12,7.12,0,0,0,40,25.59V7.43A7.12,7.12,0,0,0,37.81,2.18Z"
				})
			})
		})
	]
});
export default SvgIconSource;
